export default "__VITE_ASSET__GjF_KdJi__"